import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LearningPlayerCoreService } from './learning-player-core.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [LearningPlayerCoreService],
})
export class LearningPlayerCoreModule {}
